import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { validateModel } from '../core/validators';
import { ForgotPasswordService } from './password-forgot.service';
import { Renderer } from '@opten/renderer';
import { IfConverter } from '@opten/renderer/converters/if.converter';
import { Component } from '@opten/compiler/metadata/component';
import toggleClass from '@opten/dom/toggle-class';
import { HttpErrorResponse } from '../httpclient/httpclient';
export type ForgotPasswordState = 'code' | 'password';

@Component({ className: 'js-shop-password-forgot' })
export class ForgotPasswordComponent implements OnInit {
	private _formElement: HTMLFormElement;
	private _submitButton: HTMLElement;
	private _state: ForgotPasswordState;
	private _forgotPasswordService: ForgotPasswordService;
	private _renderer: Renderer;
	private _code: string;
	private _userName: string;
	private _renderModel: {
		state: string;
		submitSuccess?: boolean;
		submitError?: boolean;
		submitSendSuccess?: boolean;
	};

	constructor(private element: HTMLFormElement) {
		this._formElement = element;
	}

	onInit(): void {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (urlParams && urlParams.has('code') && urlParams.has('email') && urlParams.has('state')) {
			this._state = urlParams.get('state') as ForgotPasswordState;
			this._code = urlParams.get('code');
			this._userName = urlParams.get('email');
			this.username.value = urlParams.get('email');
			this._submitButton = this.element.getElementsByClassName('js-shop-password-forgot__change-password')[0] as HTMLElement;
		} else {
			this._state = 'code';
			this._submitButton = this.element.getElementsByClassName('js-shop-password-forgot__send-code')[0] as HTMLElement;
		}

		this._forgotPasswordService = new ForgotPasswordService();
		this._renderer = new Renderer([IfConverter]);
		this._renderModel = { state: this._state };
		this._renderer.render(this._formElement, this._renderModel, this);
	}

	get username() {
		return this._formElement.elements.namedItem('username') as HTMLInputElement;
	}

	get code() {
		return this._code;
	}

	get password() {
		return this._formElement.elements.namedItem('password') as HTMLInputElement;
	}

	get confirmPassword() {
		return this._formElement.elements.namedItem('confirmPassword') as HTMLInputElement;
	}

	inputChanged(event: Event) {
		this.validForm();
		if (this._state == 'password') {
			this.validConfirmPassword();
		}
	}

	private disableSubmitButton() {
		toggleClass(this._submitButton, '--disabled', true);
	}

	private enableSubmitButton() {
		toggleClass(this._submitButton, '--disabled', false);
	}

	sendCode(event: Event) {
		event.preventDefault();

		if (this.validForm()) {
			this.disableSubmitButton();
			this._submitButton.removeEventListener('click', this.sendCode, false);

			const username: string = this.username.value;

			this._forgotPasswordService.sendCode({ username }).subscribe(
				status => {
					if (status) {
						this.updateRenderModel(false, false, true);
					} else {
						this.updateRenderModel(false, true, false);
					}
					this._renderer.render(this._formElement, this._renderModel, this);
				},
				(error: HttpErrorResponse) => {
					this._renderModel.submitError = true;
					this.enableSubmitButton();
					this._renderer.render(this._formElement, this._renderModel, this);
				}
			);

		}
	}

	changePassword(event: Event) {
		event.preventDefault();
		if (this.validForm()) {
			if (this.validConfirmPassword()) {
				this.disableSubmitButton();

				const username: string = this._userName;
				const code: string = this.code;
				this._forgotPasswordService.verifyCode(username, code).subscribe(status => {
					if (status) {
						this._state = 'password';
						this.updateRenderModel();
						this._submitButton = this.element.getElementsByClassName('js-shop-password-forgot__change-password')[0] as HTMLElement;

						this._submitButton.removeEventListener('click', this.changePassword, false);
						const password: string = this.password.value;
						this._forgotPasswordService.changePassword({ username, code, password }).subscribe(
							status => {
								if (status) {
									this.updateRenderModel(true);
								} else {
									this.updateRenderModel(false, true);
								}
								this._renderer.render(this._formElement, this._renderModel, this);
							},
							(error: HttpErrorResponse) => {
								this._renderModel.submitError = true;
								this.enableSubmitButton();
								this._renderer.render(this._formElement, this._renderModel, this);
							}
						);
					} else {
						this.updateRenderModel(false, true);
					}
					this._renderer.render(this._formElement, this._renderModel, this);
				});
			}
		}
	}

	private validConfirmPassword(): boolean {
		const password: string = this.password.value;
		const confirmPassword: string = this.confirmPassword.value;
		const isValidInput: boolean = password === confirmPassword;
		let connectedElement = this.confirmPassword.parentElement.querySelector("[data-valmsg-for='" + this.confirmPassword.id + "']");

		if (connectedElement) {
			toggleClass(this.confirmPassword, 'input-validation-error', isValidInput === false);
			toggleClass(connectedElement, 'field-validation-error', isValidInput === false);
			toggleClass(connectedElement, 'field-validation-valid', isValidInput);
		}
		toggleClass(this._submitButton, '--disabled', !isValidInput);
		return isValidInput;
	}

	private validForm(): boolean {
		const fieldsToValidate: HTMLInputElement[] = [];
		switch (this._state) {
			case 'code':
				fieldsToValidate.push(this.username);
				break;
			case 'password':
				fieldsToValidate.push(this.password);
				break;
			default:
				break;
		}
		var submitsBtns: HTMLElement[] = [];
		submitsBtns.push(this._submitButton);
		return validateModel(fieldsToValidate, submitsBtns);;
	}

	private updateRenderModel(submitSuccess = false, submitError = false, submitSendSuccess = false) {
		this._renderModel.state = this._state;
		this._renderModel.submitSuccess = submitSuccess;
		this._renderModel.submitError = submitError;
		this._renderModel.submitSendSuccess = submitSendSuccess;
	}
}
